/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Constants from "../config/constants";
import TimeHelper from "../helpers/time_helper";
import Api from '@/services/api'

import { auth } from './auth.module';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth
    },    
    plugins: [createPersistedState()],
    state: {
        webAppNames: [],
        currentWebAppName: null,
        channels: [],
        currentChannel: null,
        selectedTimePeriodStart: 0,
        selectedTimePeriodEnd: 0,
        contrastTimePeriodStart: 0,
        contrastTimePeriodEnd: 0,
        timeSelection: Constants.LAST_5_MIN,
        contrastTimeSelection: Constants.LAST_60_MIN,
        targetNamedRoute: null,
    },
    mutations: {
        setSelectedTimePeriodStart(state, value) { state.selectedTimePeriodStart = value },
        setSelectedTimePeriodEnd(state, value) { state.selectedTimePeriodEnd = value },
        setContrastTimePeriodStart(state, value) { state.contrastTimePeriodStart = value },
        setContrastTimePeriodEnd(state, value) { state.contrastTimePeriodEnd = value },
        setWebAppNames(state, value) { state.webAppNames = value },
        setCurrentWebAppName(state, value) { state.currentWebAppName = value },
        setChannels(state, value) { state.channels = value },
        setCurrentChannel(state, value) { state.currentChannel = value },
        setTimeSelection(state, value) { state.timeSelection = value },
        setContrastTimeSelection(state, value) { state.contrastTimeSelection = value },
        setTargetNamedRoute(state, value) { state.targetNamedRoute = value },
    },
    actions: {
        setTimePeriod(context, timePeriod) {
            context.commit('setSelectedTimePeriodStart', timePeriod.start)
            context.commit('setSelectedTimePeriodEnd', timePeriod.end)
        },
        setContrastTimePeriod(context, timePeriod) {
            context.commit('setContrastTimePeriodStart', timePeriod.start)
            context.commit('setContrastTimePeriodEnd', timePeriod.end)
        },
        setWebAppNames(context, webAppNames) {
            context.commit('setWebAppNames', webAppNames)
        },
        setCurrentWebAppName(context, webAppName) {
            context.commit('setCurrentWebAppName', webAppName)
        },
        setChannels(context, channels) {
            context.commit('setChannels', channels)
        },
        setCurrentChannel(context, channel) {
            context.commit('setCurrentChannel', channel)
        },
        setTimeSelection(context, value) {
            context.commit('setTimeSelection', value)
            let startAndEnd = TimeHelper.startAndEndOflastXMinInEpoch(value)
            context.commit('setSelectedTimePeriodStart', startAndEnd[0])
            context.commit('setSelectedTimePeriodEnd', startAndEnd[1])
        },
        setContrastTimeSelection(context, value) {
            context.commit('setContrastTimeSelection', value)
            let startAndEnd = TimeHelper.startAndEndOflastXMinInEpoch(value)
            context.commit('setContrastTimePeriodStart', startAndEnd[0])
            context.commit('setContrastTimePeriodEnd', startAndEnd[1])
        },
        setTargetNamedRoute(context, value) {
            context.commit('setTargetNamedRoute', value)
        },
        fetchWebApps({commit, state}){
            function loop() {
                if (state.auth.isAuthenticated) {
                    console.log("Fetching web apps...");
                    Api.userApps.getWebAppList()
                    .then((response) => {
                        console.log("Web apps", response.data);
                        const webAppNames = response.data.map(element => { return element.app_name })
                        commit('setWebAppNames', webAppNames)
                        if (webAppNames.length > 0) {
                            commit('setCurrentWebAppName', webAppNames[0])
                        } else {
                            commit('setCurrentWebAppName', null)
                        }
                    })        
                }
            }
            loop();
            setInterval(loop, 5 * 60000) // Refresh every 5 minutes
        },
    },
    getters: {
        webAppNames: (state) => { return state.webAppNames },
        currentWebAppName: (state) => { return state.currentWebAppName },
        channels: (state) => { return state.channels },
        currentChannel: (state) => { return state.currentChannel },
        selectedTimePeriodStart: (state) => { 
            return state.selectedTimePeriodStart - Constants.DATA_LATENCY
        }, 
        selectedTimePeriodEnd: (state) => {
            return state.selectedTimePeriodEnd - Constants.DATA_LATENCY
        }, 
        contrastTimePeriodStart: (state) => { return state.contrastTimePeriodStart }, 
        contrastTimePeriodEnd: (state) => { return state.contrastTimePeriodEnd }, 
        getTimeSelection: (state) => { return state.timeSelection },
        getContrastTimeSelection: (state) => { return state.contrastTimeSelection },
        getFriendlySelectedTimePeriodStart: (state) => {
            return TimeHelper.toLongFormatWithoutMin( (state.selectedTimePeriodStart - Constants.DATA_LATENCY) * 1000 )
        },
        getFriendlySelectedTimePeriodEnd: (state) => {
            return TimeHelper.toLongFormatWithoutMin( (state.selectedTimePeriodEnd - Constants.DATA_LATENCY) * 1000 )
        },
        getTargetNamedRoute: (state) => { return state.targetNamedRoute }
    }    
});

